// Generated by scripts/generate-mingcute-line-icon-catalog.ts. Do not edit.

export const mingcuteLineIconAssetRevision = 'mingcute-react-1.4.1-line';
export const mingcuteLineIconAssetBasePath = '/_app-icons/mingcute-react-1.4.1-line';
export const mingcuteLineIconSpritePath = '/_app-icons/mingcute-react-1.4.1-line/sprite.svg';
